import { Component, input } from '@angular/core';

@Component({
  selector: 'app-label-pill',
  imports: [],
  // Styling lives on the HOST so the component's own element is the flex item
  // that shrinks (`min-w-0 max-w-full`). Styling only an inner wrapper leaves
  // the host content-sized, which blocks truncation when placed in a
  // width-constrained flex parent (e.g. a table cell / pills-overflow row).
  host: {
    class:
      'text-2xs border-default inline-flex min-w-0 max-w-full items-stretch overflow-hidden rounded-full border font-medium align-middle',
    '[title]': "k() + ': ' + v()"
  },
  template: `
    <span class="bg-weak text-text-secondary shrink-0 px-2 py-0.5 font-mono">{{
      k()
    }}</span>
    <span class="bg-surface text-text-primary min-w-0 truncate px-2 py-0.5 font-mono">{{
      v()
    }}</span>
  `,
  styles: ``
})
export class LabelPillComponent {
  k = input.required<string>();
  v = input.required<string>();
}
